import { API_NOT_FOUND, BAD_REQUEST } from "../../constants/error-codes"
import { ApiNotFound, BadRequest, NetworkError, RequestError } from "./exceptions"

interface ResProps {
  message?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any
  status?: number
}

export const onHttpRequestError = (res: ResProps, apiName = "") => {
  // handle network error
  if (res?.message === "Network Error") {
    throw new NetworkError(res.message, apiName, null)
  }

  // handle error
  if (res && res.status) {
    const { data, status, message = "" } = res

    const apiError = data?.error
    const apiMessage = apiError?.message || message

    switch (status) {
      case BAD_REQUEST: {
        throw new BadRequest(apiMessage, apiName, data)
      }

      case API_NOT_FOUND: {
        throw new ApiNotFound("Không tìm thấy API", apiName, data)
      }
      default: {
        throw new RequestError(apiMessage, apiName, data)
      }
    }
  }

  return res
}
